var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse2Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#D4FFEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5667 10.2391L12.9001 4.34036C12.6543 4.12142 12.3332 4 12.0001 4C11.667 4 11.3459 4.12142 11.1001 4.34036L4.43351 10.2391C4.29701 10.3607 4.188 10.5085 4.1134 10.6734C4.0388 10.8382 4.00024 11.0164 4.00018 11.1965V18.6693C3.99476 18.9966 4.11344 19.3143 4.33351 19.5618C4.45841 19.7001 4.61228 19.8107 4.78477 19.8863C4.95725 19.9618 5.14436 20.0006 5.3335 20H9.33344C9.51024 20 9.67984 19.9315 9.80484 19.8098C9.9299 19.6881 10.0001 19.523 10.0001 19.3509V15.4562C10.0001 15.284 10.0704 15.119 10.1954 14.9972C10.3204 14.8755 10.49 14.8071 10.6668 14.8071H13.3334C13.5102 14.8071 13.6798 14.8755 13.8048 14.9972C13.9299 15.119 14.0001 15.284 14.0001 15.4562V19.3509C14.0001 19.523 14.0703 19.6881 14.1953 19.8098C14.3204 19.9315 14.4899 20 14.6667 20H18.6667C18.8878 20.0018 19.1058 19.9487 19.3 19.8458C19.5113 19.7337 19.6878 19.5684 19.811 19.3671C19.9341 19.1659 19.9994 18.936 20 18.7017V11.1965C19.9999 11.0164 19.9614 10.8382 19.8868 10.6734C19.8122 10.5085 19.7032 10.3607 19.5667 10.2391Z",
    fill: "#17B986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse2Svg);
export default __webpack_public_path__ + "static/media/House2Svg.710393e8b36efa607f2114dad8303cc8.svg";
export { ForwardRef as ReactComponent };